import { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { http } from "@/lib/api";

const faq = [
  ["Sem.IA est-elle gratuite ?", "Oui, vous pouvez discuter avec Sem.IA et créer des images directement depuis le Studio."],
  ["Comment parler à Sem.IA ?", "Dans le Studio, appuyez sur le bouton micro, parlez, puis appuyez à nouveau. Sem.IA vous répond à voix haute."],
  ["Où sont mes images ?", "Toutes vos créations sont rangées dans l'onglet Galerie du Studio."],
  ["Comment activer les notifications ?", "Dans l'onglet Réglages du Studio, activez les notifications du navigateur."],
];

const empty = { name: "", email: "", subject: "", message: "" };

export default function Contact() {
  const [f, setF] = useState(empty);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await http.post("/contact", f);
      toast.success("Message envoyé ! Nous vous répondrons très vite.");
      setF(empty);
    } catch {
      toast.error("Vérifiez vos informations (email valide requis).");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-5 fade-up">
        <span className="label-mono text-[var(--accent)]">Contact</span>
        <h1 data-testid="contact-title" className="font-serif text-5xl sm:text-6xl mt-5 leading-tight">Écrivez-nous.</h1>
        <p className="text-lg text-[var(--text-secondary)] mt-6">Une question, une idée, un retour ? Nous lisons chaque message.</p>
        <Accordion type="single" collapsible className="mt-10">
          {faq.map(([q, a], i) => (
            <AccordionItem key={q} value={`f${i}`} className="border-[var(--border)]">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left text-base">{q}</AccordionTrigger>
              <AccordionContent className="text-[var(--text-secondary)]">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
      <form onSubmit={submit} className="lg:col-span-6 lg:col-start-7 card p-8 sm:p-10 space-y-5 h-fit">
        <div className="grid sm:grid-cols-2 gap-5">
          <input required data-testid="contact-name-input" className="field" placeholder="Votre nom" value={f.name} onChange={set("name")} />
          <input required type="email" data-testid="contact-email-input" className="field" placeholder="Votre email" value={f.email} onChange={set("email")} />
        </div>
        <input data-testid="contact-subject-input" className="field" placeholder="Sujet" value={f.subject} onChange={set("subject")} />
        <textarea required rows={6} data-testid="contact-message-input" className="field resize-none" placeholder="Votre message…" value={f.message} onChange={set("message")} />
        <button disabled={busy} data-testid="contact-submit-button" className="btn-primary w-full">{busy ? "Envoi…" : "Envoyer le message"} <Send size={16} /></button>
      </form>
    </div>
  );
}
